import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Paper,
  Button,
} from '@mui/material';
import {
  MdTaskAlt,
  MdArrowForward,
  MdEditNote,
} from 'react-icons/md';
import { HiInboxArrowDown } from "react-icons/hi2";
import { useState, useEffect } from 'react';
import axios from 'utils/axios';
import { useTranslation } from 'react-i18next';



const Dashboard = () => {
  const { t } = useTranslation();
  
  const [counts, setCounts] = useState({ received: 0, inProgress: 0, done: 0 });

  const fetchRequestStats = async () => {
    try {
      const response = await axios.get('/requests/requestStatusCount');
      setCounts(response.data);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    }
  };
  
  useEffect(() => {
    fetchRequestStats();
  }, []);
  
  const stats = [
    { icon: <HiInboxArrowDown size={40} color="#000" />, label: t('requests_received'), value: counts.received },
    { icon: <MdEditNote size={40} color="#000" />, label: t('requests_in_progress'), value: counts.inProgress },
    { icon: <MdTaskAlt size={40} color="#000" />, label: t('requests_done'), value: counts.done }
  ];

  const requests = Array.from({ length: 4 }, (_, i) => ({
    id: i + 1,
    text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since...',
  }));

  return (
    <Box sx={{ pt: 3, px: 3 }}>
      {/* Statističke kartice */}
      <Grid container spacing={3} mb={4}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Paper
              elevation={2}
              sx={{
                p: 3,
                height: 140,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}
            >
              {stat.icon}
              <Box>
                <Typography variant="body1" color="text.primary">
                  {stat.label}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ color: 'primary.main', fontWeight: 600 }}
                >
                  {stat.value}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Lista zahtjeva */}
      <Typography variant="h6" mb={2} color="text.primary">
        {t('requests')}
      </Typography>

      <Grid container spacing={2}>
        {requests.map((req) => (
          <Grid item xs={12} key={req.id}>
            <Paper
              elevation={0}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2,
                backgroundColor: '#f5f5f5',
              }}
            >
              <Typography variant="body2" color="text.primary">
                {req.text}
              </Typography>
              <Button
                variant="outlined"
                endIcon={<MdArrowForward color="#000" />}
                size="small"
              >
                Pogledaj zahtjev
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Dashboard;
